/** Level version history on the Node API (`/api/levels/:id/versions`). Needs the server; there is no offline copy. */

import { apiJson } from '../auth/session.ts';

export interface VersionMeta {
  id: string;
  levelId: string;
  createdAt: string;
  name: string;
  label: string | null;
  pinned: boolean;
  size: number;
  hasThumb: boolean;
}

const base = (levelId: string) => `/api/levels/${encodeURIComponent(levelId)}/versions`;

function req<T>(method: string, url: string, body?: unknown): Promise<T> {
  return apiJson<T>(method, url, body);
}

export function listVersions(levelId: string): Promise<VersionMeta[]> {
  return req('GET', base(levelId));
}

export function loadVersion<T>(levelId: string, id: string): Promise<T> {
  return req('GET', `${base(levelId)}/${encodeURIComponent(id)}`);
}

export function createVersion(doc: { id: string }, opts: { thumb?: string | null; label?: string; pinned?: boolean } = {}): Promise<{ created: boolean; version: VersionMeta }> {
  return req('POST', base(doc.id), { doc, thumb: opts.thumb ?? undefined, label: opts.label, pinned: opts.pinned });
}

export function updateVersion(levelId: string, id: string, patch: { label?: string | null; pinned?: boolean }): Promise<VersionMeta> {
  return req('PATCH', `${base(levelId)}/${encodeURIComponent(id)}`, patch);
}

export function deleteVersion(levelId: string, id: string): Promise<void> {
  return req('DELETE', `${base(levelId)}/${encodeURIComponent(id)}`);
}

export function thumbUrl(levelId: string, id: string): string {
  return `${base(levelId)}/${encodeURIComponent(id)}/thumb`;
}
